import { Icon, IconName } from 'component-library/components/icons/Icon';
import { Flex } from 'component-library/components/layout/Flex';
import { ResponsiveBody } from 'component-library/components/typography/ResponsiveBody';
import { Subheading } from 'component-library/components/typography/Subheading';
import { device } from 'component-library/styles/device';
import React, { FC } from 'react';
import styled from 'styled-components';

const StepWrapper = styled(Flex)`
  ${`@media ${device.lg}`} {
    flex-direction: row;
    align-items: center;
  }
`;

const iconSize = (size: number) => `
  width: ${size}px;
  min-width: ${size}px;
  height: ${size}px;
  min-height: ${size}px;
`;

const StyledIcon = styled(Icon)`
  ${iconSize(88)}

  ${`@media ${device.lg}`} {
    ${iconSize(64)}
    margin-bottom: 0 !important;
  }

  ${`@media ${device.xl}`} {
    ${iconSize(88)}
  }
`;

export interface StepProps {
  iconName: IconName;
  heading: string;
  body: string;
}

export const Step: FC<StepProps> = ({ iconName, heading, body }) => (
  <StepWrapper column>
    <StyledIcon
      name={iconName}
      marginRight={40}
      marginBottom={32}
      color="transparent"
    />
    <Flex column>
      <Subheading variant={1} marginBottom={8}>
        {heading}
      </Subheading>
      <ResponsiveBody variant={3}>{body}</ResponsiveBody>
    </Flex>
  </StepWrapper>
);
